import { render, staticRenderFns } from "./AdministracionMonitorComprasVentas.vue?vue&type=template&id=62244d37&"
import script from "./AdministracionMonitorComprasVentas.vue?vue&type=script&lang=js&"
export * from "./AdministracionMonitorComprasVentas.vue?vue&type=script&lang=js&"
import style0 from "./AdministracionMonitorComprasVentas.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports